export enum NoteCategory {
    airport,
    aircraft
}

export interface Note {
    id: string;
    itemId: string;
    category: NoteCategory;
    content: string;
    dateCreated: number;
    createdBy: string;
    editedBy?: string;
    dateEdited?: number;
    isCompany: boolean;
    origin?: string | null;
    departureDateTime?: number | null;
    eta?: number | null;
}

export enum NoteType {
    user,
    company
}

export type NewNote = Omit<Note, 'id'>;

export enum FlightNoteTimeSpan {
    persistent,
    flightLeg
}
